import { FC } from 'react';
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';
import BookmarksIcon from '@material-ui/icons/Bookmarks';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import ArchitectureLogo from './images/ArchitectureLogo';
import { deepPurple } from '@material-ui/core/colors';
import { Link } from '@backstage/core-components';

const HomeTab: FC = () => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography variant="h6">Welcome to</Typography>
          <Typography variant="h4" gutterBottom>
            Architecture Center
          </Typography>
          <Typography>
            <ArchitectureLogo size="l" />
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h5">Starred Links</Typography>
          <Typography variant="body1">
            <Link
              to="/docs/default/resource/architecture-center"
              target="_blank"
            >
              Full documentation <OpenInNewIcon fontSize="inherit" />
            </Link>
          </Typography>
          <List component="nav" aria-label="secondary mailbox folders">
            <ListItem
              button
              component="a"
              href="/docs/default/resource/architecture-center/architecture-reviews/introduction/"
              target="_blank"
            >
              <ListItemIcon>
                <BookmarksIcon style={{ color: deepPurple[500] }} />
              </ListItemIcon>
              <ListItemText primary="Architecture Reviews" />
            </ListItem>
            <ListItem
              button
              component="a"
              href="/docs/default/resource/architecture-center/platform-architecture-foundations/scope-strategy/"
              target="_blank"
            >
              <ListItemIcon>
                <BookmarksIcon style={{ color: deepPurple[500] }} />
              </ListItemIcon>
              <ListItemText primary="Scopes Strategy" />
            </ListItem>
            <ListItem
              button
              component="a"
              href="/docs/default/resource/architecture-center/platform-architecture-foundations/iac-journey/"
              target="_blank"
            >
              <ListItemIcon>
                <BookmarksIcon style={{ color: deepPurple[500] }} />
              </ListItemIcon>
              <ListItemText primary="IaC Journey" />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </>
  );
};

export default HomeTab;
